import { api } from './api';

export interface Office {
  id: number;
  rank: number;
  name: string;
  totalHours: number;
  totalScore: number;
  totalClients: number;
  totalReviews: number;
  agencyName: string;
  districtName: string;
  lastUpdated: string;
}

export interface OfficesResponse {
  pageNumber: number;
  pageSize: number;
  totalCount: number;
  totalPages: number;
  offices: Office[];
}

export interface OfficeError {
  message: string[];
  error: string;
  statusCode: number;
}

export interface GetOfficesParams {
  limit?: number;
  offset?: number;
  officeName?: string;
  dateFrom?: string;
  dateTo?: string;
}

export const offices = {
  getByEventId: async (eventId: number, params?: GetOfficesParams): Promise<Office[]> => {
    try {
      const response = await api.get<OfficesResponse>(`/leaderboard-events/${eventId}/offices`, {
        params,
      });
      return response.offices;
    } catch (error) {
      const officeError = error as OfficeError;
      throw officeError;
    }
  },

  getByEventIdPaged: async (
    eventId: number,
    params?: GetOfficesParams
  ): Promise<OfficesResponse> => {
    try {
      const response = await api.get<OfficesResponse>(`/leaderboard-events/${eventId}/offices`, {
        params,
      });
      return response;
    } catch (error) {
      const officeError = error as OfficeError;
      throw officeError;
    }
  },
};
